import { Object3D, Euler, Vector3, Vector2, TextureLoader } from "three";
import { BasePanel } from "./BasePanel.js";
import Util from "../utils/utils.js";
import { VGridLayout } from "../VUILib/UILayout/VLayout.js";

const defaultMatIconPath = "/assets/imgs/defaultMat.jpg";
const sliderBgPath = "/assets/vrUI/EditPanel_Material/sliderBg1.png";
const sliderHandlePath = "/assets/vrUI/EditPanel_Material/sliderHandle.png";
const dropdownBgPath = "/assets/vrUI/EditPanel_Material/dropdownBg.png";
const searchIconPath = "/assets/vrUI/EditPanel_Material/searchIcon.png";

export class EditPanel_Material extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  init() {}

  async initPanel(parent) {
    this.parent = parent;

    this.width = 2.175;
    this.height = 0.7;
    this.container = this.uilib.createContainer({
      opacity: 0,
      width: this.width,
      height: this.height,
      radius: 0,
      dragable: false,
    });
    this.parent.add(this.container);
    this.uiElements.push(this.container);
    this.container.visible = this._visible;

    this.defaultIcon = await this.manager.loadManager.loadTexture(
      defaultMatIconPath
    );
    const sliderBg = await this.manager.loadManager.loadTexture(sliderBgPath);
    const sliderHandle = await this.manager.loadManager.loadTexture(
      sliderHandlePath
    );
    const dropdownBg = await this.manager.loadManager.loadTexture(
      dropdownBgPath
    );
    const searchIcon = await this.manager.loadManager.loadTexture(
      searchIconPath
    );

    this.textureLoader = new TextureLoader();

    // 选中材质部分
    {
      const container2 = this.uilib.createContainer({
        opacity: 0.5,
        width: 0.4,
        height: 0.5,
        color: 0x4f5670,
        radius: 0.05,
        dragable: false,
      });
      this.container.add(container2);
      container2.position.x = -0.85;
      container2.position.y = -0.05;
      container2.position.z = 0.001;
      // snap
      this.selectIcon = this.uilib.createImage({
        map: this.defaultIcon,
        width: 0.35,
        height: 0.35,
        radius: 0.05,
        color: 0xffffff,
      });
      container2.add(this.selectIcon);
      this.selectIcon.position.y = 0.05;
      this.selectIcon.position.z = 0.001;
      // 材质名称
      this.setSelectMatName("");
    }

    // 材质编辑
    {
      this.updateUI = [];
      const text1 = this.uilib.createText({
        text: "材质编辑",
        textColor: 0xafbbe3,
        font: "bold",
        textSize: 0.05,
      });
      this.container.add(text1);
      text1.position.x = -0.95;
      text1.position.y = 0.275;
      this.updateUI.push(text1);

      const text2 = this.uilib.createText({
        text: "材质颜色",
        textColor: 0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      this.container.add(text2);
      text2.position.x = -0.59;
      text2.position.y = 0.15;
      this.updateUI.push(text2);

      const colorPickerContainer = this.uilib.createContainer({
        opacity: 1,
        width: 0.09,
        height: 0.09,
        color: 0xffffff,
        radius: 0.01,
        dragable: false,
      });
      this.container.add(colorPickerContainer);
      colorPickerContainer.position.x = -0.3;
      colorPickerContainer.position.y = 0.15;
      colorPickerContainer.position.z = 0.001;
      this.colorPicker = this.uilib.createColorPicker({
        orientation: "top",
        iconWidth: 0.08,
        iconHeight: 0.08,
        textSize: 0.04,
        defaultColor: 0xa0a0a0,
        needColorText: false,
      });
      this.colorPicker.addOnValueChangeEvent((color) => {
        this.manager.interface.setColor(color);
      });
      colorPickerContainer.add(this.colorPicker);
      this.colorPicker.position.z = 0.005;
      this.updateUI.push(colorPickerContainer);

      const text3 = this.uilib.createText({
        text: "纹理缩放",
        textColor: 0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      this.container.add(text3);
      text3.position.x = -0.59;
      text3.position.y = 0.05;
      this.updateUI.push(text3);

      const slider1 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: 0.45,
        height: 0.02,
        radius: 0.01,
      });
      slider1.setProgressValue(0.5);
      slider1.addOnValueChangeEvent((v) => {
        let value = v * 10;
        this.manager.interface.setTextureScale(value);
      });
      this.container.add(slider1);
      slider1.position.x = -0.3;
      slider1.position.y = -0.025;
      this.scaleSlider = slider1;
      this.updateUI.push(slider1);

      const text4 = this.uilib.createText({
        text: "纹理方向",
        textColor: 0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      this.container.add(text4);
      text4.position.x = -0.59;
      text4.position.y = -0.1;
      this.updateUI.push(text4);

      const slider2 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: 0.45,
        height: 0.02,
        radius: 0.01,
      });
      slider2.setProgressValue(0.5);
      slider2.addOnValueChangeEvent((v) => {
        let angle = v * 360;
        this.manager.interface.setTextureRotation(angle);
      });
      this.container.add(slider2);
      slider2.position.x = -0.3;
      slider2.position.y = -0.175;
      this.rotationSlider = slider2;
      this.updateUI.push(slider2);

      for (var i = 0; i < this.updateUI.length; i++) {
        this.updateUI[i].setEnabled(false);
      }
    }

    // 竖线
    {
      const line = this.uilib.createContainer({
        width: 0.005,
        height: 0.6,
        color: 0xa8b4db,
        radius: 0,
        opacity: 0.5,
      });
      this.container.add(line);
      line.position.x = 0.0;
    }

    // 搜索框
    {
      const container2 = this.uilib.createContainer({
        map: dropdownBg,
        opacity: 0.5,
        width: 0.6,
        height: 0.1,
        color: 0xffffff,
        radius: 0.0,
        dragable: false,
      });
      this.container.add(container2);
      container2.position.x = 0.32;
      container2.position.y = 0.275;
      container2.position.z = 0.001;

      const searchBtn = this.uilib.createBtn({
        map: searchIcon,
        text: "",
        color: "#A8B4DB",
        width: 0.07,
        height: 0.07,
        radius: 0,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
      });
      searchBtn.addClickEvent((btn) => {
        this.onSearchBtnClick(btn);
      });
      searchBtn.position.x = -0.22;
      searchBtn.position.z = 0.001;
      container2.add(searchBtn);

      this.inputfiled = this.uilib.createInputField({
        textColor: "#afbbe3",
        textSize: 0.045,
        textLimit: 8,
        width: 0.45,
        height: 0.1,
        radius: 0.0,
        opacity: 0.1,
        align: "left",
      });
      this.inputfiled.position.x = 0.06;
      this.inputfiled.position.z = 0.001;
      container2.add(this.inputfiled);
      this.inputfiled.addOnValueChangeEvent((str, obj) => {
        this.searchMat(str);
      });
    }

    // 材质列表
    {
      const layout = new VGridLayout();
      layout.setCellSize(new Vector2(0.23, 0.25));
      layout.setCountLimit(4);
      layout.setSpacing(new Vector2(0.02, 0.02));

      this.scrollview = this.uilib.createScrollViewGrid({
        renderOrder: 99999,
        opacity: 0.0,
        width: 1.0,
        height: 0.5,
        radius: 0,
        gridLayout: layout,
        sliderColor: 0xafbbe3,
        handleColor: 0x8993c3,
        sliderOpacity: 0.5,
        handleOpacity: 0.8,
        sliderExitState: "hide",
        sliderHeight: 0.02,
      });
      this.scrollview.addOnElementHoverEnterEvent((item) => {
        this.onHoverEnterScrollViewItem(item);
      });
      this.scrollview.addOnElementHoverExitEvent((item) => {
        this.onHoverExitScrollViewItem(item);
      });
      this.scrollview.position.x = 0.53;
      this.scrollview.position.y = -0.05;
      this.scrollview.position.z = 0.001;
      this.container.add(this.scrollview);

      // 显示搜索结果的滚动视图
      this.searchScrollview = this.uilib.createScrollViewGrid({
        renderOrder: 99999,
        opacity: 0.0,
        width: 1.0,
        height: 0.5,
        radius: 0,
        gridLayout: layout,
        sliderColor: 0xafbbe3,
        handleColor: 0x8993c3,
        sliderOpacity: 0.5,
        handleOpacity: 0.8,
        sliderExitState: "hide",
        sliderHeight: 0.02,
      });
      this.searchScrollview.addOnElementHoverEnterEvent((item) => {
        this.onHoverEnterScrollViewItem(item);
      });
      this.searchScrollview.addOnElementHoverExitEvent((item) => {
        this.onHoverExitScrollViewItem(item);
      });
      this.searchScrollview.position.x = 0.53;
      this.searchScrollview.position.y = -0.05;
      this.searchScrollview.position.z = 0.001;
      this.container.add(this.searchScrollview);
      this.searchScrollview.hide();
      //this.searchScrollview.scale.set(0, 0, 0); // 强制隐藏

      this._getData();
    }

    if (!this._visible) {
      this.closePanel();
    }
  }

  /**
   * 获取材质库列表
   */
  _getData() {
    this.manager.interface.loadMaterialData("", (array) => {
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        this.addMatItem(item, this.scrollview);
      }
    });
  }

  /**
   * 为材质库滚动视图添加单项
   * @param {*} data
   */
  async addMatItem(data, scrollview) {
    const container = this.uilib.createBtn({
      text: "",
      opacity: 0.5,
      color: 0x4f5670,
      width: 0.22,
      height: 0.25,
      radius: 0.02,
    });
    container.addHoverEnterEvent((obj) => {});
    container.addHoverExitEvent((obj) => {});
    container.addClickEvent((obj) => {
      //  选中材质
      if (obj._scrollviewData) this.onClickMatlibItem(obj._scrollviewData);
      else console.error("材质库列表错误，缺少数据");
    });
    container._scrollviewData = data;

    const tex = await this.manager.loadManager.loadTexture(
      data.image.indexOf("/assets/") >= 0
        ? data.image
        : window.base + "/" + data.image
    );
    const img = this.uilib.createImage({
      map: tex,
      width: 0.18,
      height: 0.18,
      radius: 0.01,
    });
    img.position.x = 0.001;
    img.position.y = 0.02;
    img.position.z = 0.001;
    container.add(img);
    container._icon = img;
    scrollview.setSomethingForLater(img);

    let str = data.name;
    if (!str) str = "";
    if (str.length > 7) {
      str = str.substring(0, 7) + "...";
    }

    const name = this.uilib.createText({
      text: str,
      textColor: 0xafbbe3,
      textSize: 0.025,
      font: "bold",
      align: "left",
      createdCB: (tex) => {
        scrollview.setSomethingForLater(name);
      },
    });
    name.position.x = -0.09;
    name.position.y = -0.09;
    name.position.z = 0.001;
    container.add(name);

    scrollview.addContent(container);
  }

  /**
   * 设置选中材质的图标
   * @param {*} texture 传入图片或base64字符串，如果为null则使用默认图标
   */
  setSelectMatIcon(texture) {
    if (!texture) {
      texture = this.defaultIcon;
    }
    if (this.selectIcon) {
      this.selectIcon.material.map = texture;
      this.selectIcon.material.needsUpdate = true;
    }
  }

  /**
   * 设置显示 当前选中材质名称 的文字
   * @param {*} name
   */
  setSelectMatName(name) {
    if (this.selectName) {
      this.uilib.removeUI(this.selectName);
      this.selectName = null;
    }

    if (!name) {
      name = "";
    }
    if (name.length > 9) {
      name = name.substring(0, 9) + "...";
    }

    this.selectName = this.uilib.createText({
      text: name,
      textColor: 0xafbbe3,
      textSize: 0.035,
      font: "bold",
      align: "left",
    });
    this.container.add(this.selectName);
    this.selectName.position.x = -1.025;
    this.selectName.position.y = -0.23;
    this.selectName.position.z = 0.001;
  }

  /**
   * 设置显示默认材质
   */
  setDefault() {
    this.setSelectMatIcon();
    this.setSelectMatName("");

    for (var i = 0; i < this.updateUI.length; i++) {
      this.updateUI[i].setEnabled(false);
    }
  }

  /**
   * 点击搜索按钮
   */
  onSearchBtnClick(obj) {
    const text = this.inputfiled.text;
    //  搜索材质
    this.searchMat(text);
  }

  searchMat(name) {
    if (name === "" || !name) {
      this.searchScrollview.hide();
      this.scrollview.show();
    } else {
      this.scrollview.hide();
      this.searchScrollview.show();
      this.searchScrollview.clearContent();
      this.manager.interface.loadMaterialData(name, (array) => {
        for (var i = 0; i < array.length; i++) {
          var item = array[i];
          this.addMatItem(item, this.searchScrollview);
        }
      });
    }
  }

  /**
   * 设置当前选中的场景中的材质，便于后面从材质库中选择材质替换
   * @param {*} mat
   */
  setSelectMat(mat) {
    if (!mat) {
      this.setDefault();

      this.selectMat = null;
    } else {
      // 取消选中
      if (this.selectMat && this.selectMat === mat) {
        this.setDefault();

        this.selectMat = null;
      } else {
        for (var i = 0; i < this.updateUI.length; i++) {
          this.updateUI[i].setEnabled(true);
        }

        this.selectMat = mat;

        if (this.colorPicker) {
          this.colorPicker.setColor(this.manager.interface.getColor());
        }

        let scale = this.manager.interface.getTextureScale();
        scale /= 10;
        if (this.scaleSlider) this.scaleSlider.setProgressValue(scale);
        let rot = this.manager.interface.getTextureRotation();
        rot /= 360;
        if (this.rotationSlider) this.rotationSlider.setProgressValue(rot);

        this.setSelectMatName(mat.name);
        // 获取材质截图并显示
        const texData = this.manager.materialManager.getCurrentSnapshotUrl();
        if (texData) {
          this.textureLoader.load(texData, (tex) => {
            this.setSelectMatIcon(tex);
          });
        }
      }
    }
  }

  /**
   * 点击材质库里的材质时触发
   * @param {*} matData
   */
  async onClickMatlibItem(matData) {
    if (!matData || !this.selectMat) return;
    // 将当前选中的场景中的材质属性替换为材质库中的材质属性
    this.manager.interface.replaceMatFromLib(matData.path, matData.name, () => {
      if (this.colorPicker) {
        this.colorPicker.setColor(this.manager.interface.getColor());
      }

      let scale = this.manager.interface.getTextureScale();
      scale /= 10;
      if (this.scaleSlider) this.scaleSlider.setProgressValue(scale);
      let rot = this.manager.interface.getTextureRotation();
      rot /= 360;
      if (this.rotationSlider) this.rotationSlider.setProgressValue(rot);
    });

    this.setSelectMatName(matData.name);

    const tex = await this.manager.loadManager.loadTexture(
      matData.image.indexOf("/assets/") >= 0
        ? matData.image
        : window.base + "/" + matData.image
    );
    this.curSelectLeftIcon = tex;
    this.setSelectMatIcon(tex);
  }

  /**
   * 当光标进入材质库列表时将光标所在的项信息传递到左侧的大图标中
   * @param {*} obj
   */
  onHoverEnterScrollViewItem(obj) {
    if (!obj || !obj._scrollviewData) {
      return;
    }

    this.curSelectLeftIcon = this.selectIcon.material.map;

    if (obj._icon) {
      this.setSelectMatIcon(obj._icon.material.map);
    }
    this.setSelectMatName(obj._scrollviewData.name);
  }

  /**
   * 当光标离开材质库列表时还原左侧的大图标
   * @param {*} obj
   */
  onHoverExitScrollViewItem(obj) {
    if (this.curSelectLeftIcon) {
      this.setSelectMatIcon(this.curSelectLeftIcon);
      this.curSelectLeftIcon = null;
    }
    if (this.selectMat) {
      this.setSelectMatName(this.selectMat.name);
    } else {
      this.setSelectMatName("");
    }
  }

  closePanel() {
    super.closePanel();

    // 取消当前材质选中状态
    this.manager.materialManager.setSelectMat();
    this.setSelectMat();

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    this.manager.interface.setClickMode(5); // 切换到材质库模式
  }
}
